import React from 'react'

const NoImage = ({ className = '' }) => (
  <div className={`flex items-center justify-center bg-gradient-to-br from-dorot-purple to-dorot-filter-pink text-white font-gelica font-semibold ${className}`}>
    No Image
  </div>
)

export default NoImage
